/* Lulluno theme interactions */
(function () {
  'use strict';

  var L = (window.lulluno = window.lulluno || {});
  var moneyFormat = L.moneyFormat || '${{amount}}';

  function money(cents) {
    var amount = (cents / 100).toFixed(2);
    return moneyFormat.replace('{{amount}}', amount).replace('{{ amount }}', amount);
  }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#toast');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 2600);
  }
  L.toast = toast;

  /* ---------- drawers / overlays ---------- */
  function getScrim() { return $('#scrim'); }
  function openLayer(el) {
    if (!el) return;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('open'); });
    var scrim = getScrim();
    if (scrim) { scrim.hidden = false; requestAnimationFrame(function(){ scrim.classList.add('open'); }); }
    document.body.classList.add('no-scroll');
  }
  function closeLayers() {
    $all('#cartDrawer, #navDrawer, #searchOver').forEach(function (el) {
      el.classList.remove('open');
      setTimeout(function(){ if (!el.classList.contains('open')) el.hidden = true; }, 300);
    });
    var scrim = getScrim();
    if (scrim) { scrim.classList.remove('open'); setTimeout(function(){ if(!scrim.classList.contains('open')) scrim.hidden = true; }, 300); }
    document.body.classList.remove('no-scroll');
  }
  L.closeLayers = closeLayers;

  document.addEventListener('click', function (e) {
    if (e.target.closest('#menuBtn')) { openLayer($('#navDrawer')); return; }
    if (e.target.closest('#searchBtn')) {
      openLayer($('#searchOver'));
      var inp = $('#searchInput'); if (inp) setTimeout(function(){ inp.focus(); }, 350);
      return;
    }
    if (e.target.closest('#cartBtn')) { openCart(); return; }
    if (e.target.closest('[data-close]') || e.target === getScrim()) { closeLayers(); return; }
    if (e.target.closest('#toTop')) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLayers(); });

  /* ---------- cart ---------- */
  function cartCount() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function updateBadge(count) {
    $all('#cartCount').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
  }

  function thumbUrl(url) {
    if (!url) return '';
    return String(url).replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
  }

  function renderCart(cart) {
    updateBadge(cart.item_count);
    var drawer = $('#cartDrawer');
    var dc = $('#dCount');
    if (dc) dc.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    var box = $('#dItems');
    if (!box) return;
    if (!cart.items.length) {
      box.innerHTML = '<div class="dempty"><p>Your cart is empty</p><a class="btn btn-primary" href="/collections/all">Start shopping</a></div>';
    } else {
      box.innerHTML = cart.items.map(function (it) {
        var opts = (it.options_with_values || []).map(function (o) { return o.value; }).join(' / ');
        return '<div class="ditem" data-key="' + it.key + '">' +
          '<img class="ph" src="' + thumbUrl(it.image) + '" alt="">' +
          '<div class="di"><b>' + it.product_title + '</b>' +
          (opts ? '<div class="dv">' + opts + '</div>' : '') +
          '<div class="drow"><span class="miniqty"><button type="button" data-dec>−</button><span>' + it.quantity + '</span><button type="button" data-inc>+</button></span>' +
          '<b>' + money(it.final_line_price) + '</b></div>' +
          '<button type="button" class="rm" data-remove>Remove</button></div></div>';
      }).join('');
    }
    var sub = $('#dSub');
    if (sub) sub.textContent = money(cart.total_price);
    // free shipping bar (threshold/messages come from cart-drawer section data attributes)
    var threshold = L.freeShipThreshold || 9900;
    var remainTpl = "You're {amount} away from FREE shipping";
    var doneMsg = "You've unlocked FREE shipping 🎉";
    if (drawer) {
      var tAttr = parseFloat(drawer.getAttribute('data-free-ship'));
      if (tAttr > 0) threshold = Math.round(tAttr * 100);
      if (drawer.getAttribute('data-ship-remain')) remainTpl = drawer.getAttribute('data-ship-remain');
      if (drawer.getAttribute('data-ship-done')) doneMsg = drawer.getAttribute('data-ship-done');
    }
    var fill = $('#shipFill'), msg = $('#shipMsg');
    if (fill && msg) {
      var pct = Math.min(100, Math.round(cart.total_price / threshold * 100));
      fill.style.width = pct + '%';
      if (cart.total_price >= threshold) {
        msg.textContent = doneMsg;
      } else {
        msg.textContent = remainTpl.replace('{amount}', money(threshold - cart.total_price));
      }
    }
  }

  function refreshCart() { return cartCount().then(renderCart); }

  function openCart() {
    refreshCart().then(function () { openLayer($('#cartDrawer')); });
  }
  L.openCart = openCart;
  L.refreshCart = refreshCart;

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      return refreshCart();
    }).then(function () {
      openLayer($('#cartDrawer'));
      toast('Added to cart');
    }).catch(function () { toast('Sorry, something went wrong.'); });
  }
  L.addToCart = addToCart;

  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (qa) { addToCart(qa.getAttribute('data-quick-add'), 1); return; }
    var add = e.target.closest('#addBtn');
    if (add && !add.disabled) {
      e.preventDefault(); // 拦截原生表单提交，走 AJAX 加购并打开抽屉
      var vid = add.getAttribute('data-variant');
      var form = add.closest('form');
      if (form) {
        var hid = form.querySelector('[name="id"]');
        if (hid && hid.value) vid = hid.value;
      }
      var q = parseInt(($('#qVal') || {}).textContent || '1', 10) || 1;
      if (vid) addToCart(vid, q);
      return;
    }
    var sb = e.target.closest('#sbAdd');
    if (sb && !sb.disabled) {
      var svid = sb.getAttribute('data-variant');
      if (svid) addToCart(svid, 1);
      return;
    }
    var ditem = e.target.closest('.ditem');
    if (ditem) {
      var key = ditem.getAttribute('data-key');
      if (e.target.closest('[data-inc]')) { changeQty(key, 1); return; }
      if (e.target.closest('[data-dec]')) { changeQty(key, -1); return; }
      if (e.target.closest('[data-remove]')) { changeQty(key, 0); return; }
    }
  });

  function changeQty(key, delta) {
    cartCount().then(function (cart) {
      var item = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!item) return;
      var qty = delta === 0 ? 0 : item.quantity + delta;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
      });
    }).then(refreshCart).catch(function(){});
  }

  // PDP quantity stepper
  document.addEventListener('click', function (e) {
    if (e.target.closest('#qPlus')) { bumpQty(1); }
    if (e.target.closest('#qMinus')) { bumpQty(-1); }
  });
  function bumpQty(d) {
    var el = $('#qVal');
    if (!el) return;
    el.textContent = Math.max(1, (parseInt(el.textContent, 10) || 1) + d);
  }

  /* ---------- predictive search ---------- */
  var searchTimer;
  document.addEventListener('input', function (e) {
    if (e.target.id !== 'searchInput') return;
    clearTimeout(searchTimer);
    var q = e.target.value.trim();
    var box = $('#searchResults');
    if (!box) return;
    if (q.length < 2) { box.innerHTML = ''; return; }
    searchTimer = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (res) {
          var items = (res.resources && res.resources.results && res.resources.results.products) || [];
          if (!items.length) { box.innerHTML = '<p class="nores">No matches — try "crib".</p>'; return; }
          box.innerHTML = items.map(function (p) {
            return '<a class="srow" href="' + p.url + '"><img src="' + (p.featured_image && p.featured_image.url || '') + '" alt="">' +
              '<span><b>' + p.title + '</b><i>' + money(p.price) + '</i></span></a>';
          }).join('') + '<a class="sall" href="/search?q=' + encodeURIComponent(q) + '">See all results →</a>';
        }).catch(function(){});
    }, 280);
  });

  /* ---------- accordions ---------- */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.acc-head');
    if (!head) return;
    var item = head.closest('.acc-item');
    var wasOpen = item.classList.contains('open');
    $all('.acc-item.open', item.parentElement).forEach(function (i) { i.classList.remove('open'); });
    if (!wasOpen) item.classList.add('open');
  });

  /* ---------- PDP: image lightbox (事件委托，兼容编辑器局部重载) ---------- */
  (function () {
    var dragging = false;

    function galleryImages() {
      var list = [];
      $all('.gal-thumbs button').forEach(function (b) {
        var src = b.getAttribute('data-src');
        if (src) list.push(src);
      });
      if (!list.length) {
        var m = $('#galMain');
        if (m && m.getAttribute('src')) list.push(m.getAttribute('src'));
      }
      return list;
    }

    function currentIndex(list) {
      var i = 0;
      $all('.gal-thumbs button').forEach(function (b, k) {
        if (b.classList.contains('sel')) i = k;
      });
      return Math.min(i, list.length - 1);
    }

    var lbIdx = 0;

    function lbShow(i) {
      var list = galleryImages();
      if (!list.length) return;
      lbIdx = ((i % list.length) + list.length) % list.length;
      var img = $('#lbImg');
      if (img) { img.src = list[lbIdx]; }
      var c = $('#lbCount');
      if (c) c.textContent = (lbIdx + 1) + ' / ' + list.length;
      var showNav = list.length > 1;
      var p = $('#lbPrev'), n = $('#lbNext');
      if (p) p.style.display = showNav ? '' : 'none';
      if (n) n.style.display = showNav ? '' : 'none';
    }

    function lbOpen() {
      var box = document.getElementById('pdpLightbox');
      if (!box) return;
      var list = galleryImages();
      if (!list.length) return;
      box.hidden = false;
      document.body.classList.add('no-scroll');
      lbShow(currentIndex(list));
    }

    function lbClose() {
      var box = document.getElementById('pdpLightbox');
      if (box) box.hidden = true;
      document.body.classList.remove('no-scroll');
    }
    L.closeLightbox = lbClose;

    document.addEventListener('click', function (e) {
      if (e.target.closest('#lbPrev')) { lbShow(lbIdx - 1); return; }
      if (e.target.closest('#lbNext')) { lbShow(lbIdx + 1); return; }
      if (e.target.closest('[data-lb-close]')) { lbClose(); return; }
      if (e.target.closest('.gal-main')) { lbOpen(); return; }
    });

    document.addEventListener('keydown', function (e) {
      var box = document.getElementById('pdpLightbox');
      if (!box || box.hidden) return;
      if (e.key === 'Escape') lbClose();
      else if (e.key === 'ArrowLeft') lbShow(lbIdx - 1);
      else if (e.key === 'ArrowRight') lbShow(lbIdx + 1);
    });
  })();

  /* ---------- PDP: gallery ---------- */
  document.addEventListener('click', function (e) {
    var th = e.target.closest('.gal-thumbs button');
    if (!th) return;
    var main = $('#galMain');
    var full = th.getAttribute('data-src') || th.getAttribute('data-full');
    if (main && full) {
      main.src = full;
      $all('.gal-thumbs button').forEach(function (t) { t.classList.remove('sel'); });
      th.classList.add('sel');
    }
  });

  /* ---------- PDP: preload gallery images (首切不卡顿) ---------- */
  (function () {
    function preloadGallery() {
      var seen = {};
      $all('.gal-thumbs button').forEach(function (b) {
        var src = b.getAttribute('data-src') || b.getAttribute('data-full');
        if (src && !seen[src]) { seen[src] = 1; var im = new Image(); im.src = src; }
      });
    }
    if ('requestIdleCallback' in window) requestIdleCallback(preloadGallery, { timeout: 4000 });
    else if (document.readyState === 'complete') preloadGallery();
    else window.addEventListener('load', preloadGallery);
  })();

  /* ---------- PDP: variant swatches ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.swatches .sw');
    if (!sw) return;
    $all('.swatches .sw').forEach(function (s) { s.classList.remove('sel'); });
    sw.classList.add('sel');
    var name = $('#colorName');
    if (name) name.textContent = sw.getAttribute('data-color') || '';
    var add = $('#addBtn');
    if (add && sw.getAttribute('data-variant')) add.setAttribute('data-variant', sw.getAttribute('data-variant'));
    var sticky = $('#stickyAdd');
    if (sticky && sw.getAttribute('data-variant')) sticky.setAttribute('data-variant', sw.getAttribute('data-variant'));
    // swap gallery to variant image if provided
    var img = sw.getAttribute('data-image');
    if (img) { var main = $('#galMain'); if (main) main.src = img; }
  });

  /* ---------- PDP: compare slider (事件委托，兼容编辑器局部重载) ---------- */
  (function () {
    var dragging = false;
    var cmpEl = null;

    function setPos(clientX) {
      if (!cmpEl) return;
      var r = cmpEl.getBoundingClientRect();
      if (!r.width) return;
      var pct = (clientX - r.left) / r.width * 100;
      pct = Math.max(0, Math.min(100, pct));
      var top = cmpEl.querySelector('.cmp-top');
      var handle = cmpEl.querySelector('.cmp-handle');
      if (top) top.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      if (handle) handle.style.left = pct + '%';
    }

    document.addEventListener('pointerdown', function (e) {
      var cmp = e.target.closest ? e.target.closest('#cmp') : null;
      if (!cmp) return;
      dragging = true;
      cmpEl = cmp;
      setPos(e.clientX);
      e.preventDefault();
    });

    window.addEventListener('pointermove', function (e) {
      if (!dragging || !cmpEl) return;
      if (!document.contains(cmpEl)) { dragging = false; cmpEl = null; return; }
      setPos(e.clientX);
      e.preventDefault();
    }, { passive: false });

    window.addEventListener('pointerup', function () { dragging = false; cmpEl = null; });
    window.addEventListener('pointercancel', function () { dragging = false; cmpEl = null; });
    document.addEventListener('dragstart', function (e) {
      if (e.target.closest && e.target.closest('#cmp')) e.preventDefault();
    });
  })();

  /* ---------- PDP: sticky bar (每次滚动重新查询，兼容编辑器局部重载) ---------- */
  (function () {
    function onScroll() {
      var bar = document.getElementById('stickyBar');
      if (!bar) return;
      var anchor = document.getElementById('addBtn');
      var show = anchor ? (anchor.getBoundingClientRect().bottom < 0) : (window.scrollY > 700);
      bar.hidden = !show;
      bar.classList.toggle('show', show);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  /* ---------- wishlist (localStorage) ---------- */
  var WISH_KEY = 'lulluno_wishlist';
  function getWish() { try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; } }
  function setWish(a) { try { localStorage.setItem(WISH_KEY, JSON.stringify(a)); } catch (e) {} }
  function paintWish() {
    var w = getWish();
    $all('#wishCount').forEach(function (el) { el.textContent = w.length; el.hidden = w.length === 0; });
    $all('.wishbtn').forEach(function (b) {
      var id = b.getAttribute('data-product');
      b.classList.toggle('active', id && w.indexOf(id) > -1);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.wishbtn, .btn-heart, #wishBtn');
    if (!b) return;
    var id = b.getAttribute('data-product');
    if (!id) {
      // 页头心愿单图标：仅提示数量（无独立心愿单页面）
      var w0 = getWish();
      toast(w0.length ? 'Wishlist: ' + w0.length + ' saved item' + (w0.length > 1 ? 's' : '') + ' ♡' : 'Your wishlist is empty — tap ♡ on a product to save it');
      return;
    }
    var w = getWish();
    var i = w.indexOf(id);
    if (i > -1) { w.splice(i, 1); toast('Removed from wishlist'); }
    else { w.push(id); toast('Saved to wishlist ♡'); }
    setWish(w); paintWish();
  });

  /* ---------- back to top ---------- */
  window.addEventListener('scroll', function () {
    var t = $('#toTop');
    if (t) t.hidden = window.scrollY < 600;
  }, { passive: true });

  /* ---------- init ---------- */
  cartCount().then(function (cart) { updateBadge(cart.item_count); }).catch(function(){});
  paintWish();
})();
